export const SceneBackgroundColors = {
  default: '#2E2E2E',
  engine: '#858B96',
  prefab: '#3F4652',
} as const;
